import React from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import SignalWifi4BarIcon from "@material-ui/icons/SignalWifi4Bar";
import SignalWifi2BarIcon from "@material-ui/icons/SignalWifi2Bar";
import SignalWifiOffIcon from "@material-ui/icons/SignalWifiOff";
import { i18n } from "../../translate/i18n";
import useSocketStatus from "../../hooks/useSocketStatus";

const T = "mainDrawer.appBar.socketStatus";

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    height: 26,
    padding: "0 9px 0 7px",
    margin: "0 4px",
    borderRadius: 13,
    // chip translúcido sobre a navbar colorida
    background: "rgba(255, 255, 255, 0.14)",
    color: "#fff",
    userSelect: "none",
    cursor: "default",
    lineHeight: 1,
    transition: "background 0.2s ease"
  },
  icon: {
    fontSize: 16,
    display: "block"
  },
  // pulso suave no ícone quando saudável
  pulse: {
    animation: "$pulse 2s ease-in-out infinite"
  },
  "@keyframes pulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.55 }
  },
  delay: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.2,
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap"
  },
  unit: {
    fontSize: 9,
    fontWeight: 600,
    opacity: 0.7,
    marginLeft: 1
  }
}));

/**
 * Indicador do estado do WebSocket na navbar: ícone de sinal + atraso de
 * recepção (ms). Diagnostica quando o tempo-real cai ou degrada (#4147).
 *
 *  - verde:    conectado e atraso baixo (< 1s)
 *  - amarelo:  conectado mas atraso alto (>= 1s)
 *  - vermelho: desconectado
 */
const SocketStatusIndicator = () => {
  const classes = useStyles();
  const { status, latency } = useSocketStatus();

  const high = status === "connected" && latency != null && latency >= 1000;

  let color = "#bdbdbd"; // cinza (conectando/desconhecido)
  let label = i18n.t(`${T}.connecting`);
  let Icon = SignalWifi2BarIcon;
  let healthy = false;

  if (status === "disconnected") {
    color = "#ff5252";
    label = i18n.t(`${T}.disconnected`);
    Icon = SignalWifiOffIcon;
  } else if (status === "connecting") {
    color = "#ffb74d";
    label = i18n.t(`${T}.reconnecting`);
    Icon = SignalWifi2BarIcon;
  } else if (status === "connected") {
    if (high) {
      color = "#ffb74d";
      label = i18n.t(`${T}.slow`, { ms: latency });
      Icon = SignalWifi2BarIcon;
    } else {
      color = "#69f0ae";
      label = i18n.t(`${T}.connected`);
      Icon = SignalWifi4BarIcon;
      healthy = true;
    }
  }

  const showDelay = status === "connected" && latency != null;

  return (
    <Tooltip title={label} arrow>
      <div className={classes.root}>
        <Icon
          className={`${classes.icon} ${healthy ? classes.pulse : ""}`}
          style={{ color }}
        />
        {showDelay && (
          <span className={classes.delay} style={{ color }}>
            {latency}
            <span className={classes.unit}>ms</span>
          </span>
        )}
      </div>
    </Tooltip>
  );
};

export default SocketStatusIndicator;
